var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"uppercase font-normal",on:{"click":function($event){return _vm.$router.back()}}},[_c('i8-icon',{staticClass:"mr-3",attrs:{"icon":['fal', 'chevron-left']}}),_vm._v(" Back ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }